import { Button } from '../../Button'
import { Icon } from '../../Icon'
import { tm } from '../../tm'
import { Tooltip } from '../../Tooltip'
import i18n from './i18n'
import type { Locales, Project, ProjectId } from '@captaincause/types'

interface SelectProps {
  project: Project
  locale: Locales
  disabled: boolean
  toggleSelection: (id: ProjectId) => void
  seeMore: (id: ProjectId) => void
  selected: boolean
  className?: string
}

function GreenOutline({ selected }: { selected: boolean }) {
  return (
    <div
      className={tm(
        'pointer-events-none absolute -left-2 -top-2 z-[1] h-[calc(100%+16px)] w-[calc(100%+16px)] rounded-2xl border-none p-4 opacity-0 shadow-selected transition-opacity duration-300 hover:shadow-selected focus:shadow-selected',
        selected && 'opacity-100',
      )}
    >
      <Icon
        className="absolute right-0 top-0 h-9 min-h-[36px] w-9 min-w-[36px] -translate-y-2 translate-x-2 rounded-full border-4 border-white bg-green"
        icon="check"
        fill="fill-white"
      />
    </div>
  )
}

export function Select({
  project,
  locale,
  disabled,
  seeMore,
  toggleSelection,
  selected,
  className = '',
}: SelectProps) {
  const t = i18n[locale]

  return (
    <div>
      <GreenOutline selected={selected} />
      <div className={className}>
        <p className="line-clamp-2 min-h-[48px] w-full flex-1 text-left text-base font-semibold leading-6 -tracking-[0.32px]">
          {project.name}
        </p>
        <div className="mt-3 flex flex-col gap-4 @[300px]:flex-row">
          <Tooltip
            id="selectable-project-card-disable"
            popperClassName={tm((selected || !disabled) && 'hidden')}
            clonedTriggerElementClassName="flex-1"
            label={t.tooltip}
            placement="top"
          >
            <Button
              variant="primary"
              iconClassName="relative mr-4 -ml-4"
              className={tm(
                'z-10 flex h-12 w-full min-w-[100px] flex-1 justify-center whitespace-nowrap rounded-3xl text-base font-semibold leading-8 -tracking-[0.32px] sm:h-12',
                selected &&
                  'border border-medium-red bg-white text-dark-red hover:bg-light-beige',
              )}
              innerClassName="line-clamp-1 max-w-[170px] "
              onClick={() => toggleSelection(project.id)}
              disabled={disabled}
            >
              {selected ? t.remove : t.choose}
            </Button>
          </Tooltip>
          <Button
            variant="secondary"
            innerClassName="line-clamp-1"
            className="line-clamp-1 flex h-12 w-full rounded-3xl py-3 text-base font-semibold leading-8 -tracking-[0.32px] @[300px]:min-w-[100px] @[300px]:max-w-[150px] sm:h-12"
            onClick={() => seeMore(project.id)}
            breakout
          >
            {t.discover}
          </Button>
        </div>
      </div>
    </div>
  )
}
